<template>
  <div
    :class="{ [this.getButtonClass]: true, [this.activeClass]: this.isActive, 'num-button': buttonType === 'switchNumberKeyboard' }"
    class="button"
    :style="{
      width: `${buttonWidth}px !important`,
      backgroundColor: backgroundColorStyle,
    }"
    @click="onClick"
  >
    <div v-if="!isDefault || !isSpecial || isSpace">
      {{ displayText }}
    </div>
    <i v-else :class="iconClass" />
  </div>
</template>

<script>
import { ICONS, DEFAULT_BUTTONS } from './consts/settings';
import { regexp } from './helpers/regexp';

export default {
  name: 'Button',
  props: {
    text: String,
    buttonClass: String,
    specialClass: String,
    activeClass: String,
    isCustomLangList: Boolean,
    langList: Array,
    buttonWidth: Number,
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    backgroundColorStyle() {
      if (this.buttonType === 'finish') {
        return this.$store.registratorBackgroundColor;
      }
      return '';
    },
    isSpecial() {
      return !!this.text.match(/{[\s\S]+?\|?[\s\S]+}/g);
    },
    isDefault() {
      return this.isSpecial && DEFAULT_BUTTONS.includes(this.buttonType);
    },
    isSpace() {
      return this.isSpecial && this.text.includes('space');
    },
    getButtonClass() {
      if (this.isSpecial) {
        return this.isSpace ? `${this.specialClass} space` : this.specialClass;
      }
      return this.buttonClass;
    },
    iconClass() {
      return ICONS[this.buttonType];
    },
    displayText() {
      return this.text.match(regexp.findSpecialKeyText)
        ? this.text.match(regexp.findSpecialKeyText)[0]
        : this.text.replace(regexp.findBrackets, '');
    },
    buttonType() {
      return this.text.match(regexp.findSpecialKeyValue)
        ? `${this.text.match(regexp.findSpecialKeyValue)[0]}`
        : this.text;
    },
  },
  methods: {
    onClick(event) {
      const eventName = this.isSpecial ? this.buttonType : 'input';
      const data =
        this.isSpecial && this.buttonType.includes('lang')
          ? event
          : this.buttonType;
      this.$emit(eventName, data);
    },
    onChangeLang(lang) {
      this.isActive = !this.isActive;
      this.$emit('changeLang', lang);
    },
  },
};
</script>

<style lang="scss">
.button {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 30px 0 !important;
  position: relative !important;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box !important;
  border-radius: 12px;
}
.special {
  flex: 1;
  background-color: #989898;
  color: white;
  white-space: nowrap;
}
.space {
  min-width: 200px !important;
  flex: 2.5 !important;
}
.active {
  background-color: #6fb7ff;
}
.classic_button {
  background-color: white;
  color: black;
}
.num-button {
  min-width: 105px;
}
</style>
